import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {HelperService} from "./helper.service";
import {Router} from "@angular/router";
import {CookieService} from "./cookie.service";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root',
})
export class IntegratedAppService {

  private baseUrl = environment.apiPath;

  constructor(private http: HttpClient,
              private helperService: HelperService,
              private _router: Router) {
  }

  goToApp(url: string  = '', openInNewTab: boolean = false){
    this.http.get(this.baseUrl + '/integrated-app/code').subscribe( (response: any) => {
      if(openInNewTab){
        window.open(response.integratedAppUrl+'?code='+response.code+'&redirect='+url, '_blank').focus();
      }else{
        window.location.href = response.integratedAppUrl+'?code='+response.code+'&redirect='+url;
      }
    })
  }

}
